// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo-module--Logo--2aG9C","LogoFooter":"Logo-module--Logo-footer--1rkyv"};